import { criarFinalizador } from '@/uteis/action/tramite/finalizador'
import { criarSetor } from '@/uteis/action/receber/setor'

export const receber = (processo, dadosSessao) => {
  var dados = {
    processo: processo.numeroProcesso ? processo.numeroProcesso : processo.processo,
    finalizador: criarFinalizador(dadosSessao, true),
    setor: criarSetor(dadosSessao),
    descricao: '',
    motivo: ''
  }

  return dados
}
